
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Inventory } from '../../../../backend/backendapi';
import DatePicker from 'vuejs-datepicker';

@Component({
  name: 'TabMisc',
  components: {
    DatePicker,
  },
})
export default class TabMisc extends Vue {
  @Prop({ required: true })
  readonly inventory!: Inventory | null;
}
